module.exports = __webpack_public_path__ + "static/media/G1.ca6bff38.mp3";